function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 17.2,
  y: 29.301,
  width: 114.844,
  height: 87.396,
  rx: 15.55,
  fill: "#38AFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.622 99.22c15.022 0 27.2-11.74 27.2-26.22 0-14.48-12.178-26.219-27.2-26.219-15.022 0-27.2 11.739-27.2 26.22 0 14.48 12.178 26.218 27.2 26.218z",
  fill: "#FFCF5E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.752 88.59c4.752 4.043 10.993 6.495 17.828 6.495 14.887 0 26.955-11.632 26.955-25.982 0-6.589-2.544-12.605-6.738-17.185 6.69 4.777 11.025 12.44 11.025 21.081 0 14.48-12.178 26.22-27.2 26.22-8.963 0-16.914-4.18-21.87-10.628z",
  fill: "#FCA00A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.5 78.002c-6.486 0-9.472 4.813-9.5 5.847-.028 1.034 2.796-3.508 9.5-3.508 6.704 0 9.501 4.537 9.5 3.508-.001-1.029-3.014-5.847-9.5-5.847z",
  fill: "#454545"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.027 103.283c17.329 8.914 27.879 30.83 27.879 30.83s12.656-17.147 3.407-30.516-30.558-6.838-31.286-.314z",
  fill: "#38AFFF"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.5,
  cy: 69,
  rx: 3.5,
  ry: 4,
  fill: "#454545"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 84.5,
  cy: 69,
  rx: 3.5,
  ry: 4,
  fill: "#454545"
});

function SvgLoadingError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingError);
export default __webpack_public_path__ + "static/media/loadingError.20bfbeca.svg";
export { ForwardRef as ReactComponent };